import { render, staticRenderFns } from "./mo-loading-page.html?vue&type=template&id=6ca93af3&external"
import script from "./mo-loading-page.ts?vue&type=script&lang=ts&external"
export * from "./mo-loading-page.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports